/* Regular expression pattern for validating email addresses in a specific format commonly used in Braze email marketing platform. */
/* "Display Name <email@address.com>" */
export const BRAZE_EMAIL_VALIDATION =
    /^([^<]+)\s<([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})>$/;

/* Regular expression pattern for validating email addresses in plain or mailbox format used by SFMC. */
/* "email@address.com" or "Display Name <email@address.com>" */
export const SFMC_EMAIL_VALIDATION =
    /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|([^<]+)\s<([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})>)$/;
